__turbopack_context__.v({
  "className": "apercupro_f92899cb-module__yF_cKW__className",
});
